import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
// import ServiceHighlights from "../components/ServiceHighlights";
// import ServicesOverview from "../components/ServicesOverview";
// import FAQ from "../components/FAQ";
// import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import SEO from "../components/SEO";
// import HelpButton from "../components/HelpButton";

function Offerte() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Offerte aanvragen in Arnhem - elektricieninarnhem026.nl"
        description="Laat je gegevens achter en ontvang een vrijblijvende offerte in Arnhem!"
        image="/images/banner.png"
      />
      <Header />
      <HeroSection
        title="Direct een vrijblijvende offerte aanvragen in Arnhem"
        description="Laat je gegevens achter en ontvang een vrijblijvende offerte in Arnhem!"
        // imageSrc="/images/mirt2.png"
      />

      {/* <ServiceHighlights /> */}
      {/* <ServicesOverview /> */}
      {/* <FAQ /> */}

      <PartnerMarquee />

      {/* <HelpButton /> */}
      {/* <Footer /> */}
    </div>
  );
}

export default Offerte;
